<template>
  <div
    ref="wrapper"
    class="wrapper"
  >
    <svg
      ref="svg"
      v-resize="debounceOnResize"
    />
  </div>
</template>

<script>
import { CalendarChart } from '@/helpers/CalendarChart'
import debounce from '@/helpers/debounce'
import { seriesColors } from '@/helpers/chartColors'

export default {
  props: {
    data: Array,
  },
  watch: {
    data(newVal) {
      this.chart.update(newVal)
    },
  },
  mounted() {
    console.log('wrapper width:', this.$refs.wrapper.clientWidth)
    const width = this.$refs.wrapper.clientWidth
    
    const height = this.$refs.wrapper.clientHeight
    this.chart = new CalendarChart(this.$refs.svg, this.data, { width, height, colors: seriesColors, fillOpacity: 0.1 })
  },
  methods: {
    resize() {
      // this.chart.resize(this.$refs.wrapper.clientWidth, this.$refs.wrapper.clientWidth * 0.75)
      this.chart.resize(this.$refs.wrapper.clientWidth, this.$refs.wrapper.clientHeight)
    },
    debounceOnResize: debounce(function () {
      this.resize()
    }, 300),
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}

svg {
  display: block;
}
</style>